export enum DirectoryKey {
  DIRECTORY = 'directory',
  DIRECTORY_SHARED = 'directoryShared',
  DIRECTORY_PERMISSIONS = 'directoryPermissions',
}
